import type { RouterRootContext } from '@/router'
import { checkAuthRoleBeforeLoad } from '@/components/beforeLoad'
import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/')({
  component: Outlet,
  errorComponent: GlobalErrorPage,
  beforeLoad: (ctx) => {
    checkAuthRoleBeforeLoad(ctx.context as RouterRootContext, 'admin')
    if (ctx.location.pathname === '/admin') throw redirect({ to: '/admin/users', search: { limit: undefined, page: undefined } })
  },
})
